import { fontSizes, fontWeights, lineHeights } from "@dana/MobiusOverrides/styles/typography";
import { productListStyles } from "@dana/Overrides/Widgets/OnePageCheckoutConfirmation/OnePageCheckoutConfirmationProductList";
import mergeToNew from "@insite/client-framework/Common/mergeToNew";
import { BaseTheme } from "@insite/mobius/globals/baseTheme";
import { GridOffset } from "@insite/mobius/GridContainer";
import { GridItemStyle } from "@insite/mobius/GridItem";
import { breakpointMediaQueries } from "@insite/mobius/utilities";
import { css } from "styled-components";

productListStyles.itemContainer = mergeToNew(productListStyles.itemContainer, {
    css: css`
        @media print {
            > ${GridOffset} {
                gap: 20px;

                ${GridItemStyle} {
                    padding: 10px;
                }
            }
        }
    `,
});

productListStyles.productImageGridItem = mergeToNew(productListStyles.productImageGridItem, {
    width: [4, 4, 2, 2, 2],
});

productListStyles.productInfoGridItem = mergeToNew(productListStyles.productInfoGridItem, {
    width: [12, 9, 8, 8, 8],
});

productListStyles.subtotalGridItem = mergeToNew(productListStyles.subtotalGridItem, {
    width: [12, 3, 2, 2, 2],
    css: css`
        ${({ theme }: { theme: BaseTheme }) =>
            breakpointMediaQueries(
                theme,
                [
                    css`
                        justify-content: flex-start;
                    `,
                    null,
                    null,
                    null,
                ],
                "max",
            )}
    `,
});

productListStyles.productErpNumberText = mergeToNew(productListStyles.productErpNumberText, {
    weight: fontWeights.semiBold,
    css: css`
        @media print {
            display: block;
            font-size: ${fontSizes.small};
            line-height: ${fontSizes.small};
        }
    `,
});

productListStyles.productDescriptionText = mergeToNew(productListStyles.productDescriptionText, {
    css: css`
        @media print {
            display: block;
            font-size: ${fontSizes.small};
            line-height: ${fontSizes.small};
        }
    `,
});

productListStyles.qtyOrderedText = mergeToNew(productListStyles.qtyOrderedText, {
    size: fontSizes.medium,
    lineHeight: lineHeights.medium,
    css: css`
        @media print {
            display: block;
            font-size: ${fontSizes.small};
            line-height: ${fontSizes.small};
        }
    `,
});

productListStyles.productPrice = mergeToNew(productListStyles.productPrice, {
    priceLabelText: {
        size: fontSizes.medium,
        lineHeight: lineHeights.medium,
        css: css`
            @media print {
                display: block;
                font-size: ${fontSizes.small};
                line-height: ${fontSizes.small};
            }
        `,
    },
    price: {
        priceText: {
            weight: fontWeights.semiBold,
        },
        unitOfMeasure: {
            unitOfMeasureText: {
                weight: fontWeights.semiBold,
            },
        },
    },
});

productListStyles.subtotalText = mergeToNew(productListStyles.subtotalText, {
    weight: fontWeights.semiBold,
});
